<template lang="js">
<div id="setting-window" v-show="show">
    <div class="window-content">
        <div class="window-title">
            <span id="title">{{title}}</span>
            <img class="close-btn" src="../../assets/art/setting/close.svg" alt="" @click="close"/>
        </div>
        <div id="bar"></div>
        <div class="content">
            <SettingItem :watchValue="'isFixed'" :itemTxt="'頁面顯示比例'" :optionA="'固定'" :optionB="'延伸'"></SettingItem>
            <SettingItem :watchValue="'isWindow'" :itemTxt="'檢視模式'" :optionA="'視窗'" :optionB="'全螢幕'"></SettingItem>
            <SettingItem :watchValue="'isShowPenChange'" :itemTxt="'畫筆工具切換區'" :optionA="'開啟'" :optionB="'關閉'"></SettingItem>
            <SettingItem :watchValue="'isPenClick'" :itemTxt="'畫筆點擊按鈕'" :optionA="'開啟'" :optionB="'關閉'"></SettingItem>
            <SettingItem v-show="!(store.nowView == VIEW_TYPE.ANDROID || store.nowView == VIEW_TYPE.IOS)" :watchValue="'useCustomPlayer'" :itemTxt="'影片播放器'" :optionA="'電子書內嵌'" :optionB="'使用者電腦預設'"></SettingItem>
            <SettingItem :watchValue="'toolbarPosition'" :itemTxt="'工具列位置'" :optionA="'下方'" :optionB="'左方'" :optionC="'右方'"></SettingItem>
        </div >
    </div >
</div >
</template>
<script>
import CommonWindow from '../common/CommonWindow.vue';
import SettingItem from './SettingItem.vue';
import { store } from '../../store';
import { VIEW_TYPE } from '@/js/view_type';
export default {
    name: "Setting",
    components: {
        CommonWindow,
        SettingItem
    },
    data: function () {
        return {
            title: "偏好設定",
            show: false,
            store,
            VIEW_TYPE
        }
    },
    methods: {
        close() {
            this.show = false;
        }
    }
}
</script>

<style lang="css" scoped>
#setting-window {
    z-index: var(--z-index-setting);
    position: absolute;
    margin: auto;
    left: 0px;
    right: 0px;
    top: 20%;
    background: rgb(255, 255, 255);
    width: 650px;
    padding-bottom: 10px;
    border-radius: 20px;
    border-style: solid;
    border-color: rgb(0, 89, 173);
}

.window-content {
    position: relative;
    width: 96%;
    left: 2%;
    padding-bottom: 15px;
}

.close-btn {
    position: absolute;
    left: 95%;
    transform: translateY(8px);
    width: 30px;
    height: 30px;
}

.window-title {
    height: 3rem;
    width: 100%;
    font-size: 2rem;
    color: rgb(0, 0, 0);
    font-weight: bold;
    padding-top: 8px;
}

#bar {
    width: 100%;
    height: 20px;
    background-color: rgb(0, 89, 173);
    border-radius: 5px;
    margin-bottom: 12px;
}

#content {
    margin-top: 30px;
}
</style>